/**
 * Auth Module
 */
import Vue from 'vue'
import Nprogress from 'nprogress'
import AuthApi from '@/api/auth'
import router from '../../../router'
import storageUtil from '@/helpers/storage'

const state = {
  user: storageUtil.getKey('acceso', true)
}

// getters
const getters = {
  getAcceso: state => state.acceso
}

// actions
const actions = {
  acceso (context, payload) {
    const { user } = payload
    Nprogress.start()
    return new Promise((resolve, reject) => {
      AuthApi.acceso(user).then(
        data => {
          // setTimeout(() => {
          context.commit('accesoMedicoSuccess', data.acceso)
          // }, 500)
        },
        error => {
          // setTimeout(() => {
          context.commit('accesoMedicoFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  }
}

// mutations
const mutations = {
  setearAcceso (state, usuario) {
    state.acceso = usuario
    storageUtil.setKey('acceso', usuario)
  },
  accesoMedicoSuccess (state, acceso) {
    Nprogress.done()
    state.acceso = acceso
    storageUtil.setKey('acceso', acceso)
    router.push({ name: 'dashboard' })
  },
  accesoMedicoFailure (state, error) {
    Nprogress.done()
    Vue.notify({
      group: 'general',
      type: 'error',
      text: error.message
    })
    return error
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
